var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowToPlayEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3213_3368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.0768 26.9539C55.2067 25.0739 31.4321 1.21567 30.2264 0.00012207C26.1073 4.09953 4.11909 26.0041 0 30.1133C4.10925 34.2275 25.6594 55.8761 29.7736 60.0001C33.8878 55.8958 55.8711 33.9913 60 29.8869L57.0768 26.9489V26.9539Z",
    fill: "url(#paint0_linear_3213_3368)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2147 6.79878L53.1966 29.8748L29.7811 53.1961L6.79917 30.1154L30.2147 6.79878Z",
    fill: "white",
    stroke: "#0A0A0A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 20H19V38H42V20Z",
    fill: "white",
    stroke: "#000212",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5091 20H19.4909C19.2198 20 19 20.2118 19 20.473V23.527C19 23.7882 19.2198 24 19.4909 24H41.5091C41.7802 24 42 23.7882 42 23.527V20.473C42 20.2118 41.7802 20 41.5091 20Z",
    fill: "#211627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1279 25.7665H21.6633V29.231H25.1279V25.7665Z",
    fill: "#211627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1279 31.4801H21.6633V34.9447H25.1279V31.4801Z",
    fill: "#211627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3864 25.7665H33.9219V29.231H37.3864V25.7665Z",
    fill: "#211627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8694 30.9843H32.4048V34.4488H35.8694V30.9843Z",
    fill: "#211627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.217 25.7665H27.7524V29.231H31.217V25.7665Z",
    fill: "#211627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.217 31.4801H27.7524V34.9447H31.217V31.4801Z",
    fill: "#211627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.752 29.9156L39.3827 28.4668C39.7561 28.133 40.3258 28.1675 40.6553 28.5417L41.291 29.2592L37.7485 29.9206L37.752 29.9156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1109 36.1721C28.9378 35.245 28.1828 34.5718 27.2984 34.4552C26.9054 34.401 26.6593 34.4552 26.6593 34.4552L26.1928 32.0695L42.9612 28.9385L43.4091 31.4416C42.5841 31.5957 41.9506 32.1287 41.7472 32.9016C41.6731 33.1883 41.6564 33.4995 41.7152 33.8142C41.9295 34.9625 43.0441 35.7226 44.1881 35.509L44.6367 37.9117L27.8725 41.0419C27.8725 41.0419 27.8683 41.0427 27.8675 41.0385L27.4196 38.64C28.5679 38.4256 29.3245 37.3161 29.1101 36.1678L29.1109 36.1721Z",
    fill: "#271B2E",
    stroke: "#000212",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5667 36.5493C36.3457 38.571 35.8433 38.7088 34.8911 36.8622C34.5199 36.0997 33.3517 36.089 32.6382 35.9449C31.1721 35.1404 34.4047 34.5633 34.2527 33.443C34.3402 32.9689 34.4505 31.1791 35.2945 32.069C35.687 32.6867 36.1128 33.7646 36.9629 33.8391C37.4369 33.9267 39.231 34.0362 38.3368 34.8809C37.7192 35.2735 36.6412 35.6992 36.5667 36.5493Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3213_3368",
    x1: 30,
    y1: 0.00012207,
    x2: 30,
    y2: 60.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B385F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAD0E9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3213_3368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToPlayEvent);
export default __webpack_public_path__ + "static/media/how-to-play_event.30eeb7524bbcdd03e194af62f09c9a28.svg";
export { ForwardRef as ReactComponent };